<div
  class="ui-table-filter"
  [class]="popoverCssClass"
>
  <div
    @showEnter
    class="ui-table-filter-content"
  >
    <hard-form-grid
      [config]="{
        params: {
          direction: 'column',
          fields: fields,
        },
      }"
      [form]="form"
    ></hard-form-grid>

    <div class="flex justify-end px-2 mt-3">
      <div class="mr-2">
        @if (!hideResetBtn) {
          <hard-button
            (click)="clear()"
            data-id="clearButton"
          >
            {{ "base.resetion" | hardTranslate }}
          </hard-button>
        }
      </div>

      <hard-button
        type="success"
        (click)="search()"
        data-id="searchButton"
      >
        {{ "base.search" | hardTranslate }}
      </hard-button>
    </div>
  </div>
</div>
